import { styled } from '@mui/material';

import { WorkloadOptimizationState } from '@cast/types';

/**
 * @deprecated Use WoopIndicator instead with variant prop set to "on" or "off"
 */
export const PolicyIndicator = styled('div')<{
  managementOption: WorkloadOptimizationState;
  disabled?: boolean;
}>(({ managementOption, disabled, theme }) => {
  return {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor:
      managementOption === WorkloadOptimizationState.MANAGED
        ? disabled
          ? theme.palette.blue[200]
          : theme.palette.blue[500]
        : disabled
        ? theme.palette.grey[200]
        : theme.palette.grey[300],
  };
});
